import { Component, OnDestroy, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TenantSidebarComponent } from './tenant-sidebar/tenant-sidebar.component';
import { SignalRService } from '../../services/signal-r.service';

@Component({
  selector: 'app-tenant-layout',
  standalone: true,
  imports: [RouterOutlet, TenantSidebarComponent],
  template: `
    <div class="tenant-app-layout">
      <div class="tenant-app-sidebar-container">
        <app-tenant-sidebar class="tenant-app-sidebar"></app-tenant-sidebar>
      </div>
      <div class="tenant-app-content">
        <router-outlet></router-outlet>
      </div>
    </div>
  `,
  styles: `
    .tenant-app-layout {
      display: flex;
      height: calc(100vh - 65px);
      width: 100%;
      position: relative;
    }
    
    .tenant-app-sidebar-container {
      width: 300px;
      height: 100%;
      min-width: 300px;
      box-shadow: var(--sidebar-layout-shadow);
      overflow: hidden;
    }
    
    .tenant-app-sidebar {
      display: block;
      height: 100%;
      overflow: hidden;
    }
    
    .tenant-app-content {
      flex: 1;
      height: 100%;
      min-width: 500px;
      overflow-y: auto;
      overflow-x: hidden;
    }
  `
})
export class TenantLayoutComponent implements OnInit, OnDestroy {
  constructor (private signalRService: SignalRService) {}

  ngOnInit(): void {
    this.signalRService.connect();
  }

  ngOnDestroy(): void {
    this.signalRService.disconnect();
  }
}
